<template>
  <a-drawer :width="550" :title="null" placement="right" :open="visible" @close="handleClose" :closable="false"
    class="message-drawer">
    <a-spin :spinning="messageLoading">
      <div class="content">
        <div class="message-header">
          <div class="left-message-header">
            <h2 class="message-title">Notifications</h2>
            <div class="clear-all-btn" @click="clearAllMessages">
              <Icon name="brush" class="clear-all-icon" />
              Clear All
            </div>
          </div>
          <button class="close-btn" @click="handleClose">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
        <div class="message-list">
          <div class="message-top">
            <div class="top-btn-box">
              <div class="filter-btn" @click="handleFilterClick('all')"
                :class="{ 'filter-btn-active': activeFilter === 'all' }">
                All
              </div>
              <div class="filter-btn" @click="handleFilterClick('general')"
                :class="{ 'filter-btn-active': activeFilter === 'general' }">
                General
              </div>
              <div class="filter-btn" @click="handleFilterClick('payments')"
                :class="{ 'filter-btn-active': activeFilter === 'payments' }">
                Payments
              </div>
              <div class="filter-btn" @click="handleFilterClick('acc')"
                :class="{ 'filter-btn-active': activeFilter === 'acc' }">
                ACC Authorization
              </div>
            </div>
            <div class="right-btn" ref="settingsBtn">
              <Icon name="a-shezhi2" class="setting-icon" @click="toggleSettingsPopup" />

              <!-- 自定义设置弹窗 -->
              <div v-if="showSettingsPopup" class="settings-popup">
                <div class="notification-settings">
                  <div class="settings-header">
                    <h2 class="settings-title">Notification Settings</h2>
                  </div>
                  <div class="settings-content">
                    <div class="setting-item" v-for="value in notificationList" :key="value.category">
                      <div class="setting-info">
                        <div class="setting-label">{{ value.categoryDisplayName }}</div>
                        <div class="setting-description">{{ value.categoryDescription }}</div>
                      </div>
                      <a-switch v-model:checked="value.emailEnabled" @change="handleChange(value)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="message-items" ref="messageItemsRef"
            :style="{ padding: hasScrollbar ? '0px 16px 0 0' : '0 0 16px' }">
            <div v-if="messages?.length == 0" class="empty-state">
              <a-empty />
            </div>
            <div v-else>
              <div v-for="message in messages" :key="message.id" class="message-item"
                :class="`message-type-${message.category}`" @click="handleClick(message)">
                <div class="message-content-wrapper">
                  <div class="message-content">
                    <div class="message-header-box">
                      <div class="message-header">
                        <div class="message-icon">
                          <img v-if="message.category === 'acc'" src="../assets/images/img/acc.png" alt="ACC"
                            class="img-style" />
                          <img v-else-if="message.category === 'general'" src="../assets/images/img/General.png"
                            alt="General" class="img-style" />
                          <img v-else-if="message.category === 'payments'" src="../assets/images/img/Payments.png"
                            alt="Payments" class="img-style" />
                        </div>
                        <div class="message-title">
                          {{ computedTitle(message.category) }}
                        </div>
                      </div>
                      <div class="message-header-right">
                        <div class="redIot" v-if="!message.isRead">

                        </div>
                        <Icon name="jiantou-you-jiacu" />
                      </div>
                    </div>


                    <div class="message-description">
                      <div class="message-description-title">
                        {{ message.title }}
                      </div>
                      <div class="message-description-content" v-if="message.eventType !== 'seller_sub_account_invited'&&message.eventType !== 'seller_billing_generated'&&message.eventType !=='seller_sub_account_invited'">
                        <!-- {{ message.description }} -->
                        <div class="message-rich-content" v-html="message.content" v-if="message.category == 'acc'">
                         
                        </div>
                        <!-- seller_sub_account_invited
seller_billing_generated -->
                        <div class="message-rich-content" v-if="message.category !== 'acc'&&message.eventType !== 'seller_sub_account_invited'&&message.eventType !== 'seller_billing_generated'&&message.eventType !=='seller_sub_account_invited'">
                           {{ returnContent(message.eventType) }}
                           <span v-if="message.eventType === 'seller_billing_status_changed'">
                            Site:
                            <Icon :name="COUNTRY_BASE_ICON[message?.marketplace]" />
                            {{message.marketplace}}
                           </span>
                        </div>
                        <!-- <a-textarea
                  :disabled="!message.content"
                 style="margin-top: 10px"
                :rows="15"
                  v-model:value="message.content" 
                  /> -->
                      </div>
                      <div class="message-description-general" v-if="message.category === 'general'">
                        <div class="message-description-general-item">
                          <Icon name="user" />
                          <span>{{message.eventType=='seller_amazon_account_bound'?'Amazon Seller Name':'Username'}}:{{ returnUserName(message.eventType,message) }} </span>
                        </div>
                        <div class="message-description-general-item">
                          <Icon name="sms" />
                          <span>{{message.eventType=='seller_amazon_account_bound'?'Email':'Invited Email'}}: {{ returnEmail(message.eventType,message) }}
                          </span>

                        </div>
                        <div class="message-description-general-item">
                          <Icon name="clock" />
                          <span>{{message.eventType=='seller_amazon_account_bound'?'Authorization Time':'Sent Time'}} : {{ returnTime(message.eventType,message) }}</span>
                        </div>
                      </div>
                      <div class="message-description-payments" v-if="message.category === 'payments'&&message.eventType !== 'seller_billing_status_changed'">
                        <div class="message-description-payments-item">
                          Marketplace:  <Icon :name="COUNTRY_BASE_ICON[message?.marketplace]" />
                            {{message.marketplace}}
                        </div>
                        <div class="message-description-payments-item">
                          Invoice Date: {{ message.extraData.billingDate ? message.extraData.billingDate : '--' }}
                        </div>
                        <div class="message-description-payments-item">
                          Amount: {{ AMAZON_CURRENCY_MAPPER[message.extraData.marketplace] }}{{ message.extraData.amount
                          }}
                        </div>
                        <div class="message-description-payments-item">
                          Transaction Cycle: {{ message.extraData.transactionCycle ? message.extraData.transactionCycle
                            : '--'
                          }}
                        </div>
                        <div class="message-description-payments-item">
                          Due Date: {{ message.extraData.dueDate ? message.extraData.dueDate : '--' }}
                        </div>
                      </div>
                      <div class="message-description-payments-box" v-if="message.category === 'payments'&&message.eventType == 'seller_billing_status_changed'">
                        <div v-for="(value,key) in message.extraData.billingDetails" class="message-description-payments-box-box" v-if="message.extraData.billingDetails">
                        <div class="message-description-payments-box-item">
                          Invoice Date: {{value.billingDate}}
                        </div>
                         <div class="message-description-payments-box-item" >
                          Amount: {{ AMAZON_CURRENCY_MAPPER[message.extraData.marketplace] }}{{value.amount}}
                        </div>
                         <div class="message-description-payments-box-item">
                          Status Changed to: {{value.newStatus}}
                        </div>
                        </div>
                        
                      </div>
                      <div class="message-description-payments-content" v-if="message.category === 'payments'">
                        <div v-if="message.eventType === 'seller_billing_status_changed'">
                          <div>
                            For more details, visit the invoice page.
                          </div>
                          <div>
                            If you have business on other sites, switch sites from the top right to view invoices for other sites
                          </div>
                        </div>
                        <div v-else>
                           If you have business on other sites, switch sites from the top right to view invoices for other sites.
                        </div>
                         <!-- {{ message.eventType === 'seller_billing_status_changed'?'For more details, visit the invoice page.<br>If you have business on other sites, switch sites from the top right to view invoices for other sites':'If you have business on other sites, switch sites from the top right to view invoices for other sites.' }}  -->
                       </div> 
                      <div class="message-description-btn"
                      @click.stop="handleCategoryClick(message)"
                        v-if="message.category === 'acc' || message.category === 'payments'">
                        {{ message.category === 'acc' ? 'Go to Acc Authorization' : 'Go to Invoices' }}
                        <Icon name="jiantou-hengxian-you-cu" />
                      </div>
                    </div>

                    <div class="message-actions">
                      <span>
                        {{ moment(message.createdAt).tz(timezone).format('YYYY-MM-DD HH:mm:ss') }}
                      </span>
                      <!-- <div class="right-actions">
                        <Icon name="a-Frame1912057349" />
                        <span>Opt out</span>
                       </div> -->
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </a-spin>
  </a-drawer>
</template>

<script setup>
import { ref, computed, watch, nextTick, onMounted, onUnmounted } from 'vue'
import { message } from 'ant-design-vue'
import { useMessageDrawerStore } from '../storeData/messageDrawer'
import { homeApi } from '../server/index'
import { useUserInfoStore } from '../storeData/index'
import { storeToRefs } from 'pinia'
import moment from 'moment'
import { COUNTRY_TIME_TZ, AMAZON_CURRENCY_MAPPER,CURRENCY_MAPPER } from '~/contants/common.js'
import { useRouter } from 'vue-router'
import Icon from '~/components/Icon.vue'
import { COUNTRY_BASE_ICON } from '~/contants/common'
const store = useUserInfoStore()
const { userInfo } = storeToRefs(store)
const timezone = COUNTRY_TIME_TZ[userInfo.value?.countryCode] || COUNTRY_TIME_TZ['US']
const getMarketplaceHost = () => CURRENCY_MAPPER[userInfo.value?.countryCode]?.host
const notificationList = ref([])
const router = useRouter()
const props = defineProps({
  // 是否加载中
  loading: {
    type: Boolean,
    default: false,
  },
})


const emit = defineEmits([
  'close',
  'markAsRead',
  'delete',
  'refresh',
  'messageClick',
  'scrollToBottom',
  'sendMessage',
])

// 时间格式化函数
const formatMessageTime = (timestamp) => {
  if (!timestamp) return ''

  const messageTime = moment(timestamp)
  const now = moment()
  const today = moment().startOf('day')
  const yesterday = moment().subtract(1, 'day').startOf('day')
  const dayBeforeYesterday = moment().subtract(2, 'day').startOf('day')
  const threeDaysAgo = moment().subtract(3, 'day').startOf('day')

  if (messageTime.isSame(today, 'day')) {
    // 今天显示时间
    return messageTime.format('HH:mm')
  } else if (messageTime.isSame(yesterday, 'day')) {
    // 昨天显示 Yesterday
    return 'Yesterday'
  } else if (messageTime.isSame(dayBeforeYesterday, 'day')) {
    // 前天显示 2 days ago
    return '2 days ago'
  } else if (messageTime.isSame(threeDaysAgo, 'day')) {
    // 大前天显示 3 days ago
    return '3 days ago'
  } else {
    // 更早的时间显示日期
    return messageTime.format('YYYY/MM/DD')
  }
}
const returnContent=(type)=>{
  let str=''
  if(type === 'seller_amazon_account_bound'){
  str='You have successfully bound and authorized an Amazon seller account.'
  }
  if(type === 'seller_sub_account_invited'){
    str=''
  }
  if(type === 'seller_sub_account_responded'){
    str='The invited sub-account user has completed registration.'
  }
  if(type === 'seller_billing_generated'){
    str=''
  }
  if(type === 'seller_billing_paid'){
    str='Your invoice is overdue. Please process it promptly.'
  }
  if(type === 'seller_billing_status_changed'){
    str='Your invoice status has changed:'
  }
  if(type==='seller_billing_delayed'){
    str='Your invoice is overdue. Please process it promptly.'
  }
  return str
}
// 计算消息的 showTime 属性
const calculateShowTime = (messages) => {
  if (!messages || messages.length === 0) return messages

  const processedMessages = [...messages]

  // 按时间排序（从早到晚）
  processedMessages.sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  )

  // 初始化所有消息的 showTime 为 false
  processedMessages.forEach((msg) => {
    msg.showTime = false
  })

  // 第一个消息总是显示时间
  if (processedMessages.length > 0) {
    processedMessages[0].showTime = true
  }

  // 遍历消息，计算时间间隔
  for (let i = 1; i < processedMessages.length; i++) {
    const currentMessage = processedMessages[i]
    const previousMessage = processedMessages[i - 1]

    const currentTime = moment(currentMessage.createdAt)
    const previousTime = moment(previousMessage.createdAt)

    // 检查是否跨天
    const isDifferentDay = !currentTime.isSame(previousTime, 'day')

    // 检查时间间隔是否超过3小时
    const timeDiffInHours = currentTime.diff(previousTime, 'hours', true)
    const isMoreThan3Hours = timeDiffInHours >= 3

    // 如果跨天或间隔超过3小时，则显示时间
    if (isDifferentDay || isMoreThan3Hours) {
      currentMessage.showTime = true
    }
  }

  return processedMessages
}

// 全局状态管理
const messageDrawerStore = useMessageDrawerStore()
const visible = ref(false)
// 内部状态控制显示隐藏 - 使用全局状态
// const visible = computed({
//   get: () => messageDrawerStore.visible,
//   set: (value) => messageDrawerStore.setVisible(value),
// })

const activeFilter = ref('all')
const messageListRef = ref()
const receiverId = ref(null)
const notificationSettings = ref({
  newPartnerships: false,
  partnershipDeactivated: true,
  partnershipUpdates: true,
  productUpdates: true
})
const showSettingsPopup = ref(false)
const settingsBtn = ref(null)
const messageItemsRef = ref(null)
// 聊天详情相关状态
const showChatDetail = ref(false)
const currentChatUser = ref({})
const currentUser = ref({})
const chatMessages = ref([])
const newMessage = ref('')
const chatContentRef = ref()
const messageInputRef = ref()
const messages = ref([])
const total = ref(0)
const messageLoading = ref(false)
const param = ref({
  page: 1,
  size: 5,
})

// 定时器相关
const refreshTimer = ref(null)
const REFRESH_INTERVAL = 0.5 * 60 * 1000 // 2分钟
const isTimerActive = ref(false)

// 处理关闭
const handleClose = () => {
  visible.value = false
  emit('close')
}
const getMessagesListSeller = async () => {

  const data = await homeApi.sellerNotificationsList({
    ...param.value,
    marketplace: getMarketplaceHost()
  })

  if (data.success) {
    total.value = data.data.data.length
    // 去重：在追加新数据前，过滤掉已存在的消息
    const existingIds = new Set(messages.value.map(item => item.id))
    const newMessages = data.data.data.filter(item => !existingIds.has(item.id))
    messages.value = [...messages.value, ...newMessages]
  } else {
    message.error(data.error)
  }
  // homeApi.sellerMessagesList(param.value).then(res => {
  //   console.log(res,'seller信息列表')
  //   total.value = res.data?.total||0
  // })
}
const getMessagesListPublisher = async () => {
  const data = await homeApi.publisherNotificationsList(param.value)
  if (data.success) {
    messages.value = data.data.data
    // 计算所有消息的unreadCount累加值
    total.value = data.data.data.reduce(
      (sum, message) => sum + (message.unreadCount || 0),
      0
    )
    filteredMessages.value = messages.value
  } else {
    message.error(data.error)
  }
  // homeApi.publisherMessagesList(param.value).then(res => {
  //   console.log(res,'publisher信息列表')
  //   total.value = res.data?.total||0
  // })
}
// 加载消息列表
const loadMessages = async () => {
  messageLoading.value = true
  if (userInfo.value?.userType === 'publisher') {
    await getMessagesListPublisher()
  } else if (userInfo.value?.userType === 'seller') {
    await getMessagesListSeller()
  }
  messageLoading.value = false
}

const computedTitle = (type) => {
  if (type == 'acc') {
    return 'ACC Authorization'
  }
  if (type == 'general') {
    return 'General'

  }
  if (type == 'payments') {
    return 'Payments'
  }
}

const handleFilterClick = (filter) => {
  activeFilter.value = filter
  messages.value = []
  if (activeFilter.value === 'all') {
    param.value={
      page: 1,
      size: 5,
    }
    loadMessages()
   
  } else {
    param.value={
      page: 1,
      size: 5,
      category: activeFilter.value,
    }
    loadMessages()
   
    // const filtered = messages.value.length > 0 ? messages.value.filter(message => message.category === activeFilter.value) : [

    // ]
    // return filtered
  }
}
// 筛选后的消息列表


// 处理滚动事件
// const handleScroll = (event) => {
//   const { scrollTop, scrollHeight, clientHeight } = event.target

//   // 判断是否滚动到底部（允许5px的误差）
//   const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5

//   if (isAtBottom) {
//     emit('scrollToBottom', {
//       scrollTop,
//       scrollHeight,
//       clientHeight,
//     })
//   }
// }

// 处理聊天滚动事件
const handleChatScroll = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target

  // 判断是否滚动到底部
  const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5

  // if (isAtBottom) {
  //   emit('scrollToBottom', {
  //     scrollTop,
  //     scrollHeight,
  //     clientHeight,
  //   })
  // }
}
const handleCategoryClick=(messageItem)=>{
   homeApi.sellerNotificationsMarkAsRead(messageItem.id).then(res => {
    if (res.success) {
      messages.value.forEach(item => {
        if (item.id === messageItem.id) {
          item.isRead = true
        }
      })
      emit('refresh')

    } else {
      message.error(res.error)
    }
  })
  if (messageItem.category === 'acc') {
    router.push('/seller/creatorConnections/authorization')
    visible.value = false
  }
  if (messageItem.category === 'payments') {
    router.push('/seller/finance/payments')
    visible.value = false
  }
}
const handleClick = (messageItem) => {
  // handleMarkAsRead(messageItem)
  // if (messageItem.isRead) {
  //   return
  // }
  homeApi.sellerNotificationsMarkAsRead(messageItem.id).then(res => {
    if (res.success) {
      messages.value.forEach(item => {
        if (item.id === messageItem.id) {
          item.isRead = true
        }
      })
      emit('refresh')

    } else {
      message.error(res.error)
    }
  })
}

// 处理发送消息
const handleSendMessage = async () => {
  if (!newMessage.value.trim()) return

  // 暂停定时器避免冲突
  pauseRefreshTimer()

  const messageData = {
    message: newMessage.value.trim(),
    receiverId: receiverId.value,
    messageType: 'text',
  }
  let res
  if (userInfo.value?.userType === 'seller') {
    res = await homeApi.sellerMessagesSend(messageData)
  } else {
    res = await homeApi.publisherMessagesSend(messageData)
  }
  if (res.success) {
    newMessage.value = ''
    // 重新加载消息后滚动到底部
    await loadMessagesById(receiverId.value)
    // 等待消息加载完成后再滚动
    nextTick(() => {
      messageInputRef.value?.focus()
      scrollToBottomDelayed(300)
    })
  } else {
    message.error(res.error)
  }

  // 恢复定时器
  resumeRefreshTimer()
}

const handleChange = (item) => {

  const param = notificationList.value.map(notification => {
    if (notification.category === item.category) {
      return {
        category: item.category,
        emailEnabled: item.emailEnabled,
      }
    }
    return {
      category: notification.category,
      emailEnabled: notification.emailEnabled,
    }
  })

  homeApi.changeSellerNotificationsSettings({ settings: param }).then(res => {
    if (res.success) {
      // message.success('更新成功')
    } else {
      message.error(res.error)
    }
  })
}

// 滚动到底部
const scrollToBottom = () => {
  nextTick(() => {
    if (chatContentRef.value) {
      // 使用平滑滚动
      chatContentRef.value.scrollTo({
        top: chatContentRef.value.scrollHeight,
        behavior: 'smooth',
      })
    }
  })
}

// 强制滚动到底部（不使用平滑滚动）
const scrollToBottomImmediate = () => {
  nextTick(() => {
    if (chatContentRef.value) {
      chatContentRef.value.scrollTop = chatContentRef.value.scrollHeight
    }
  })
}

// 延迟滚动到底部，确保DOM完全更新
const scrollToBottomDelayed = (delay = 100) => {
  setTimeout(() => {
    if (chatContentRef.value) {
      chatContentRef.value.scrollTop = chatContentRef.value.scrollHeight
    }
  }, delay)
}

// 启动定时刷新
const startRefreshTimer = () => {
  // 如果抽屉未显示，不启动定时器
  if (!messageDrawerStore.visible) {
    return
  }

  // 清除现有定时器
  stopRefreshTimer()

  // console.log('启动定时刷新器，间隔:', REFRESH_INTERVAL / 1000, '秒')
  isTimerActive.value = true

  refreshTimer.value = setInterval(async () => {
    if (messageDrawerStore.visible && isTimerActive.value) {
      try {
        if (showChatDetail.value) {
          // 在聊天详情页面，刷新当前聊天消息
          if (receiverId.value) {
            // console.log('定时刷新聊天消息:', receiverId.value)
            await loadMessagesById(receiverId.value)
          }
        } else {
          // 在消息列表页面，刷新消息列表
          // console.log('定时刷新消息列表')
          await loadMessages()
        }
      } catch (error) {
        console.error('定时刷新消息失败:', error)
      }
    } else {
      // 如果抽屉关闭或定时器被禁用，停止定时器
      stopRefreshTimer()
    }
  }, REFRESH_INTERVAL)
}

// 停止定时刷新
const stopRefreshTimer = () => {
  if (refreshTimer.value) {
    // console.log('停止定时刷新器')
    clearInterval(refreshTimer.value)
    refreshTimer.value = null
    isTimerActive.value = false
  }
}

// 暂停定时刷新
const pauseRefreshTimer = () => {
  isTimerActive.value = false
  // console.log('暂停定时刷新器')
}

// 恢复定时刷新
const resumeRefreshTimer = () => {
  if (messageDrawerStore.visible) {
    isTimerActive.value = true
    // console.log('恢复定时刷新器')
  }
}


const loadMessagesById = async (id) => {
  messageLoading.value = true

  if (userInfo.value?.userType === 'publisher') {
    await publisherMessagesList(id)
  } else if (userInfo.value?.userType === 'seller') {
    await sellerMessagesList(id)
  }
  messageLoading.value = false
}
// 显示抽屉
const show = async (notificationSettings) => {

  param.value={
      page: 1,
      size: 5,
    }
    if(notificationSettings){
      showSettingsPopup.value = true
      if( showSettingsPopup.value ){
       homeApi.sellerNotificationsSettings().then(res => {
      if (res.success) {

        notificationList.value = res.data
      } else {
        message.error(res.error)
      }
    })
      }
    }
  messages.value = []
  // messageDrawerStore.show()
  visible.value = true
  loadMessages()
  nextTick(() => {
    checkScrollbar()
    // 添加滚动事件监听
    if (messageItemsRef.value) {
      messageItemsRef.value.addEventListener('scroll', handleScroll)
    }
  })
  // activeFilter.value = 'all'
  // await loadMessages()

  // // 启动定时刷新
  // startRefreshTimer()

  // emit('refresh')
}

// 隐藏抽屉
const hide = () => {
  messageDrawerStore.hide()
  // 停止定时刷新
  stopRefreshTimer()
}

// 切换显示状态
const toggle = () => {
  messageDrawerStore.toggle()
  if (messageDrawerStore.visible) {
    // 启动定时刷新
    startRefreshTimer()
    emit('refresh')
  } else {
    // 停止定时刷新
    stopRefreshTimer()
  }
}

// 检测是否有滚动条
const hasScrollbar = ref(false)

// 检测滚动条状态
const checkScrollbar = () => {
  nextTick(() => {
    if (messageItemsRef.value) {
      hasScrollbar.value = messageItemsRef.value.scrollHeight > messageItemsRef.value.clientHeight
    }
  })
}

const returnUserName=(type,message)=>{
  if(type=='seller_amazon_account_bound'){
    if(!message.extraData.amazonSellerName){
      return '--'
    }else{
      return message.extraData.amazonSellerName
    }
    }else{
      if(!message.extraData.userName){
         return '--'
      }
      else{
      return message.extraData.userName
      }
    }
  
}
const returnEmail=(type,message)=>{
  if(type=='seller_amazon_account_bound'){
    if(!message.extraData.amazonSellerAccountEmail){
      return '--'
    }else{
      return message.extraData.amazonSellerAccountEmail
    }
    }else{
      if(!message.extraData.accountEmail){
         return '--'
      }
      else{
      return message.extraData.accountEmail
      }
    }
}
const returnTime=(type,message)=>{
  if(type=='seller_amazon_account_bound'){
    if(!message.extraData.connectionTime){
      return '--'
    }else{
      return moment(message.extraData.connectionTime).tz(timezone).format('YYYY-MM-DD HH:mm:ss')
    }
    }else{
      if(!message.extraData.createDate){
         return '--'
      }
      else{
      return moment(message.extraData.createDate).tz(timezone).format('YYYY-MM-DD HH:mm:ss')
      }
    }
}
// amazonSellerAccountEmail
// 监听filteredMessages变化，重新检测滚动条
// watch(
//   () => filteredMessages.value,
//   () => {
//     checkScrollbar()
//   },
//   { deep: true }
// )

// 监听activeFilter变化，滚动到顶部
watch(
  () => activeFilter.value,
  () => {
    // 滚动到顶部
    if (messageItemsRef.value) {
      messageItemsRef.value.scrollTop = 0
    }
  }
)

// 组件挂载后检测滚动条
onMounted(() => {
  checkScrollbar()

})

// 组件卸载前移除滚动事件监听
onUnmounted(() => {
  if (messageItemsRef.value) {
    messageItemsRef.value.removeEventListener('scroll', handleScroll)
  }
})

// 节流函数
const throttle = (func, delay) => {
  let timer = null
  return function() {
    if (!timer) {
      timer = setTimeout(() => {
        func.apply(this, arguments)
        timer = null
      }, delay)
    }
  }
}

// 滚动事件处理
const handleScroll = throttle((e) => {
  const target = e.target
  // 检测是否滚动到底部
  if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
    // console.log('执行')
    // 滚动到底部，触发加载更多
    handleLoadMore()
  }
}, 300)
const clearAllMessages = async () => {
  if (userInfo.value?.userType === 'publisher') {
    // await publisherNotificationsReadAll()
  } else if (userInfo.value?.userType === 'seller') {
    homeApi.sellerNotificationsClearAll(
      {
        marketplace: getMarketplaceHost()
      }
    ).then(res => {
      if (res.success) {
        messages.value = []
        emit('refresh')
      } else {
        message.error(res.error)
      }
    })
  }
}
// 加载更多数据
const handleLoadMore = () => {
  // 检查数据是否已经加载完毕
  if (total.value < param.value.size) {
    console.log('No more data to load')
    return
  }

  // 滚动到底部，触发加载更多
  console.log('Scroll to bottom, load more data')
  // page+1
  param.value.page += 1
  // 调用获取消息的方法
  if (userInfo.value?.userType === 'publisher') {
    getMessagesListPublisher()
  } else if (userInfo.value?.userType === 'seller') {
    getMessagesListSeller()
  }
}

// 切换设置弹窗显示状态
const toggleSettingsPopup = () => {
  showSettingsPopup.value = !showSettingsPopup.value
  if (showSettingsPopup.value) {
    homeApi.sellerNotificationsSettings().then(res => {
      if (res.success) {

        notificationList.value = res.data
      } else {
        message.error(res.error)
      }
    })
  }
}

// 点击外部关闭弹窗
const handleClickOutside = (event) => {
  if (showSettingsPopup.value && settingsBtn.value && !settingsBtn.value.contains(event.target)) {
    showSettingsPopup.value = false
  }
}

// 监听点击事件
onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
  stopRefreshTimer()
})

// 暴露方法给父组件使用
defineExpose({
  show,
  hide,
  toggle,
  startRefreshTimer,
  stopRefreshTimer,
  pauseRefreshTimer,
  resumeRefreshTimer,
  isTimerActive,
})



// // 监听visible变化，可以在这里添加刷新逻辑
// watch(
//   () => messageDrawerStore.visible,
//   async (newVal) => {
//     if (newVal) {
//       // 启动定时刷新
//       startRefreshTimer()
//       emit('refresh')
//     } else {
//       // 停止定时刷新
//       stopRefreshTimer()
//     }
//   }
// )

// // 监听参数变化
// watch(
//   () => messageDrawerStore.currentParam,
//   (newParam) => {
//     if (newParam && messageDrawerStore.visible) {
//       // 当参数变化时，重新加载消息
//       // console.log(newParam,'newParam')
//       receiverId.value = newParam
//       showChatDetail.value = true
//       loadMessagesById(newParam)
//     }
//   }
// )

// 监听聊天消息变化，自动滚动到底部
watch(
  () => chatMessages.value,
  () => {
    if (showChatDetail.value) {
      scrollToBottomDelayed(100)
    }
  },
  { deep: true }
)

// 监听showChatDetail变化，重新启动定时器以确保正确的刷新逻辑
watch(
  () => showChatDetail.value,
  () => {
    if (messageDrawerStore.visible) {
      // 重新启动定时器以应用新的刷新逻辑
      startRefreshTimer()
    }
  }
)

// 组件销毁时清理定时器
onUnmounted(() => {
  stopRefreshTimer()
})
</script>

<style lang="less" scoped>
.message-description-payments-content{
  font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 13px;
leading-trim: NONE;
line-height: 22px;
letter-spacing: 0.5px;
padding: 10px 0;
}
.message-description-payments-box{
  background-color: rgba(248, 248, 250, 1);
  padding: 2px 16px;
}
.message-description-payments-box-box{
font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 13px;
leading-trim: NONE;
line-height: 22px;
letter-spacing: 0.5px;
padding: 10px 0;
}
.message-description-payments-box-box:not(:last-child){
  border-bottom: 1px solid rgba(232, 229, 237, 1);
 
}

.img-style {
  width: 24px;
  height: 24px;
}

.message-drawer {
  :deep(.ant-drawer-body) {
    padding: 16px !important;
  }
}

.content {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

// 全局样式，确保抽屉样式生效
:global(.ant-drawer .ant-drawer-body) {
  padding: 16px !important;
}

// 更具体的选择器
:global(.ant-drawer-right .ant-drawer-body) {
  padding: 16px !important;
}

.send-btn-container {
  margin-top: 30px;
  margin-bottom: 10px;
  padding: 0 11px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .text-total-container {
    color: #0f062980;
    font-family: 'Sora';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;

    letter-spacing: 0.4px;
  }

  .text-total {
    color: #0f0629;
    font-family: 'Sora';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
  }
}

.message-panel {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.message-header-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(232, 229, 237, 1);
}

.message-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.redIot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(235, 78, 61, 1);
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;

  .left-message-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .clear-all-btn {
    border: 1px solid rgba(204, 199, 217, 1);
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0.4px;
    cursor: pointer;
  }

  .clear-all-icon {
    font-size: 16px;
  }

  .message-title {
    color: #0f0629;
    font-family: 'Sora';
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0.5px;
    opacity: 0.9;
    margin: 0;
  }

  .close-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    color: #666;
    transition: all 0.2s;

    &:hover {
      background: #f5f5f5;
      color: #333;
    }
  }
}

.filter-tabs {
  display: flex;
  padding: 12px 16px;
  gap: 8px;
}

.message-list {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background-color: rgba(248, 248, 250, 1);
  display: flex;
  flex-direction: column;

  .empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #999;

    .empty-icon {
      font-size: 48px;
      margin-bottom: 16px;
    }

    p {
      margin: 0;
      font-size: 16px;
    }
  }

  .message-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
  }

  .right-btn {
    .popover-top {
      padding: 20px 0;
    }
  }

  .top-btn-box {
    display: flex;
    gap: 16px;
    align-items: center;

    .filter-btn {
      padding: 4px 8px;
      background-color: rgba(241, 240, 245, 1);
      border-radius: 8px;
      cursor: pointer;
      font-family: Sora;
      font-weight: 500;
      font-style: Medium;
      font-size: 14px;
      leading-trim: NONE;
      line-height: 20px;
      letter-spacing: 0.4px;
      text-align: center;

    }

    .filter-btn-active {
      background-color: rgba(138, 100, 244, 1);
      color: rgba(255, 255, 255, 1);
    }
  }
}

.message-items {
  flex: 1;
  overflow-y: auto;

  .message-item {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    transition: all 0.2s;
    cursor: pointer;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .message-content-wrapper {
      display: flex;
      gap: 12px;
      // margin-bottom: 12px;
    }

    .message-icon {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }

    .message-content {
      flex: 1;
    }

    .message-header {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      padding: 0;
      // padding: 0 0 12px 0;
    }

    .message-title {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: 0.4px;
    }

    .message-time {
      color: #0f062980;
      font-family: 'Sora';
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.4px;
    }

    .message-description {
      border-bottom: 1px solid rgba(232, 229, 237, 1);

      .message-description-title {
        font-family: Sora;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 26px;
        letter-spacing: 0%;
        padding: 12px 0;
      }

      .message-description-content {
        font-family: Sora;
        font-weight: 400;
        font-style: Regular;
        font-size: 13px;
        leading-trim: NONE;
        line-height: 22px;
        letter-spacing: 0.5px;
        padding-bottom: 12px;

        .message-rich-content {
          font-family: Sora;
          font-weight: 400;
          font-style: Regular;
          font-size: 13px;
          leading-trim: NONE;
          line-height: 22px;
          letter-spacing: 0.5px;
          white-space: pre-wrap;

          /* 富文本内容样式 */
          p {
            margin: 0 0 8px 0;
          }

          a {
            color: #8a64f4;
            text-decoration: underline;
          }

          strong {
            font-weight: 600;
          }
        }
      }

      .message-description-general {
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .message-description-general-item {
          display: flex;
          align-items: center;
          gap: 10px;
          font-family: Sora;
          font-weight: 400;
          font-style: Regular;
          font-size: 13px;
          leading-trim: NONE;
          line-height: 22px;
          letter-spacing: 0.5px;

        }
      }

      .message-description-payments {
        border-radius: 4px;
        background-color: rgba(248, 248, 250, 1);
        padding: 12px 16px;
        margin-bottom: 10px;

        .message-description-payments-item {
          font-family: Sora;
          font-weight: 400;
          font-style: Regular;
          font-size: 13px;
          leading-trim: NONE;
          line-height: 22px;
          letter-spacing: 0.5px;
          color: rgba(15, 6, 41, 0.9);
        }
      }

      .message-description-btn {
        margin-bottom: 10px;
        border-radius: 8px;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        background-color: rgba(138, 100, 244, 0.14);
        font-family: Sora;
        font-weight: 400;
        font-style: Regular;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 28px;
        letter-spacing: 0.5px;
        padding: 6px 16px;
        cursor: pointer;
      }
    }

    .message-actions {

      display: flex;
      justify-content: space-between;
      font-family: PingFang SC;
      font-weight: 400;
      font-style: Regular;
      font-size: 13px;
      leading-trim: NONE;
      line-height: 20px;
      letter-spacing: 0%;
      color: rgba(147, 143, 159, 1);
      padding-top: 10px;
    }
    .right-actions{
      display: flex;
      gap: 4px;
      align-items: center;
    }
    .action-link {
      color: #8a64f4 !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      padding: 0 !important;

      &:hover {
        color: #724bde !important;
      }
    }

    .message-footer {
      display: flex;
      justify-content: flex-end;
    }

    .opt-out-btn {
      color: #0f062980 !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      padding: 0 !important;
    }
  }
}

.message-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  margin-right: 16px;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  :deep(img) {
    max-height: 56px;
    border-radius: 50%;
    object-fit: contain;
  }

  .default-avatar {
    width: 56px;
    height: 56px;
    background: #d9d9d9;
    border: 1px solid #d9d9d9;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 600;
    font-size: 18px;
  }
}

.message-content {
  flex: 1;
  min-width: 0;

  .message-header-info {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 4px;

    .sender-name {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      letter-spacing: 0.5px;
      opacity: 0.9;
    }

    .message-time {
      color: #0f062980;
      font-family: 'Sora';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;

      letter-spacing: 0.5px;
      opacity: 0.9;
    }
  }

  .message-text {
    color: #0f0629b3;
    font-family: 'Sora';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.5px;
    opacity: 0.9;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.unread-badge {
  background: #eb4e3d;
  color: white;
  border-radius: 20px;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;

  font-family: 'Sora';
  font-size: 14.4px;
  font-style: normal;
  font-weight: 400;
  line-height: 14.4px;
  font-weight: 600;
  margin-left: 8px;
  flex-shrink: 0;
}

// 自定义滚动条
.message-list::-webkit-scrollbar {
  width: 4px;
}

.message-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.message-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.message-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}



.message-wrapper {
  display: flex;
  flex-direction: column;

  &.own-message {
    align-items: flex-end;
  }

  .message-time {
    text-align: center;
    font-size: 12px;
    color: #999;
    margin-bottom: 8px;
    width: 100%;
  }

  .message-bubble {
    display: flex;
    align-items: flex-start;
    max-width: 100%;

    .message-avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 16px;
      flex-shrink: 0;
      overflow: hidden;
      background: #d9d9d9;
      border: 1px solid #d9d9d9;
      display: flex;
      align-items: center;
      justify-content: center;

      :deep(img) {
        max-height: 32px;
        object-fit: cover;
      }

      .default-avatar {
        width: 100%;
        height: 100%;
        background: #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        font-weight: 600;
        font-size: 12px;
      }
    }

    .message-text {
      padding: 6px 10px;

      border-radius: 8px;
      background: #fff;
      word-wrap: break-word;
      max-width: 82%;
      margin-right: 48px;
    }

    &.own .message-avatar {
      margin-right: 0px;
      margin-left: 16px;
    }

    &.own .message-text {
      background: linear-gradient(0deg, #8a64f426 0%, #8a64f426 100%), #fff;
      color: white;
      color: #0f0629b3;
      font-family: 'Sora';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;

      letter-spacing: 0.5px;
      opacity: 0.9;
      margin-left: 48px;
      margin-right: 0px;
    }
  }
}

.chat-input {
  padding: 16px 5px;
  background: #fff;
  border-top: 1px solid #f0f0f0;

  .input-container {
    .message-input {
      flex: 1;
      font-family: 'Sora';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0.5px;
      outline: none;
      transition: border-color 0.2s;

      &:focus {
        border-color: #6c5ce7;
      }

      &::placeholder {
        color: #999;
      }
    }
  }
}

// 聊天内容滚动条
.chat-content::-webkit-scrollbar {
  width: 4px;
}

.chat-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.chat-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.chat-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.setting-icon {
  font-size: 16px;
  cursor: pointer;
}

.right-btn {
  position: relative;
}

.settings-popup {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  z-index: 1000;
}

// .settings-popup::before {
//   content: '';
//   position: absolute;
//   top: -4px;
//   right: 12px;
//   width: 8px;
//   height: 8px;
//   background: #ffffff;
//   transform: rotate(45deg);
//   box-shadow: -1px -1px 2px rgba(0, 0, 0, 0.05);
// }

.notification-settings {
  width: 476px;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.settings-header {
  margin-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 12px;
}

.settings-title {
  color: #0f0629;
  font-family: 'Sora';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;

  letter-spacing: 0.5px;
  margin: 0;
}

.settings-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.setting-info {
  flex: 1;
  margin-right: 16px;
}

.setting-label {
  color: rgba(15, 6, 41, 0.9);
  font-family: Sora;
  font-weight: 500;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 0.4px;
  margin-bottom: 9px;
}

.setting-description {
  color: rgba(15, 6, 41, 0.5);
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0.4px;

}

:deep(.ant-switch-checked) {
  background-color: #8a64f4 !important;
}

:deep(.ant-switch) {
  // width: 44px !important;
  // height: 24px !important;
}

// :deep(.ant-switch-handle) {
//   width: 20px !important;
//   height: 20px !important;
//   margin-top: 2px !important;
// }

:deep(.ant-popover-inner) {
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

:deep(.ant-popover-inner-content) {
  padding: 0 !important;
}
</style>

<style lang="less">
/* 全局样式，确保抽屉样式生效 */
.ant-drawer .ant-drawer-body {
  padding: 0 !important;
}

.ant-drawer-right .ant-drawer-body {
  padding: 0 !important;
}
</style>
